import { useSelector } from 'react-redux';

import { selectDataHasInsurance } from 'connect/selectors';
import { CheckoutStateHandler } from 'pages/checkout/connect/state-handlers';
import { CheckoutState } from 'pages/checkout/connect/types';

export const useHasInsurance = () => {
  const { insurance } = useSelector<any, CheckoutState>(CheckoutStateHandler.selector);
  const hasInsuranceFromCheckout = insurance?.hasInsurance ?? insurance?.provider?.id;

  const hasInsuranceFromMatch = useSelector(selectDataHasInsurance);

  return Boolean(hasInsuranceFromCheckout ?? hasInsuranceFromMatch);
};
